import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export interface SidebarRoute {
  path: string;
  label: string;
  icon: string;
  roles?: string[];
  mouseOver?: string;
}

export interface SidebarSection {
  key: string;
  title: string;
  routes: SidebarRoute[];
  roles?: string[];
  tenant?: string[];
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, MatIconModule, MatListModule, NgIf, NgFor, MatTooltipModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  constructor(private readonly authenticationService: AuthenticationService){} 

  openSections: { [key: string]: boolean } = {
    client: true,
    indici: true,
    crawling: true,
    query: true,
    users: true,
    reports: true
  };

  toggleSection(section: string) {
    this.openSections[section] = !this.openSections[section];
  }

  sidebarSections: SidebarSection[] = [
    {
      key: 'client',
      title: 'Client Configuration',
      routes: [
        { path: '/client', icon: 'computer', label: 'Client' },
        { path: '/onebox', icon: 'inventory_2', label: 'Onebox' },
        { path: '/biasing-policy', icon: 'emoji_events', label: 'Policy di Biasing' },
        { path: '/suggestion', icon: 'lightbulb', label: 'Suggestion' }
      ]
    },
    {
      key: 'indici',
      title: 'Indici e Alias',
      routes: [
        { path: '/indici', icon: 'article', label: 'Indici' },
        { path: '/alias', icon: 'link', label: 'Alias' },
        { path: '/diagnostica', icon: 'bug_report', label: 'Diagnostica' },
        { path: '/delete_document', icon: 'delete', label: 'Cancellazione documenti' },
        { path: '/meta', icon: 'info', label: 'Fields' }
      ]
    },
    {
      key: 'crawling',
      title: 'Gestione Crawling',
      tenant: ['EDIDOMUS'],
      routes: [
        { path: '/crawling-json-xml', icon: 'code', label: 'Import' },
        { path: '/crawling-web', icon: 'public', label: 'Crawling WEB' }
      ]
    },
    {
      key: 'query',
      title: 'Impostazioni Query',
      routes: [
        { path: '/sinonimi', icon: 'menu_book', label: 'Sinonimi' },
        { path: '/keyword-da-ignorare', icon: 'block', label: 'Keyword da ignorare', mouseOver: 'Configurazione Blacklist' },
        { path: '/keyword-da-non-espandere', icon: 'speaker_notes', label: 'Keyword da non espandere', mouseOver: 'Configurazione Stopword' }
      ]
    }, 
    {
      key: 'users',
      title: 'Gestione Utenze',
      roles: ['BACKOFFICE_ADMIN'],
      routes: [
        { path: '/users', icon: 'people_outline', label: 'Utenti e Ruoli'}
      ]
    },
    {
      key: 'reports',
      title: 'Reportistica',
      routes: [
        { path: '/reports', icon: 'description', label: 'Reports'}
      ]
    }
  ];

  filteredSections: SidebarSection[] = [];

  ngOnInit(): void {

    const userRoles = this.authenticationService.getRealmRoles();
    const userSubRoles = this.authenticationService.getSubRoles();
    const currentTenant = this.authenticationService.getTenant();

    this.filteredSections = this.sidebarSections.filter(section => 
      this.canAccess(section, userRoles, currentTenant)
    ).map(section => ({
      ...section,
      routes: section.routes.filter(route => 
        this.canAccess(route, userRoles, currentTenant)
      )
    }));
  }

  private canAccess(item: any, userRoles: string[], currentTenant: string): boolean {
    //Controllo ruoli (whitelist)
    const hasRole = !item.roles || item.roles.some((r: string) => userRoles.includes(r))
    
    //Controllo tenant (blacklist)
    const hasTenant = !item.tenant || !item.tenant.includes(currentTenant);

    return hasRole && hasTenant; 
  }

}